import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import {CurrencyExchange} from "@irati/types"
import cashbackForCurrencyQuery, {cashbackForCurrencyKey} from "./queries/cashbackForCurrency"

class CurrencyService extends PBService {
  async getFPCashbackForCurrency(currency: string, options: QueryOptions = {}): Promise<CurrencyExchange> {
    const variables = {currency}
    return client
      .query({fetchPolicy: "cache-first", ...options, query: cashbackForCurrencyQuery, variables})
      .then(({data}) => data[cashbackForCurrencyKey])
  }
}

const currencyService = new CurrencyService({errorHandlers: []})

export default currencyService
